import {CA} from '../../shared/scripts/analytics/Analytics'
import {StorageWrapper} from '../../shared/scripts/StorageWrapper'
import {ClientUserState} from '../../shared/scripts/ClientUserState'
import {UIMRequestPushNotification, PushNotificationPopupIntentEnum} from './ui_popup/UIMRequestPushNotification'

export class UIMLoginController {
    private readonly loginButtons: HTMLElement[]
    private readonly guestLogin: HTMLLinkElement

    constructor() {
        this.loginButtons = Array.from(document.getElementsByClassName('popup-login-btn')) as HTMLElement[]
        this.guestLogin = document.getElementById('continue-as-guest') as HTMLLinkElement

        this.loginButtons.forEach((btn) => {
            if(btn == null) return
            btn.addEventListener('click', (e) => {
                btn.classList.add('loading')

                setTimeout(() => {
                    this.removeLoading()
                }, 7500)
            })
        })

        this.handleUserLoginFlow()

        this.guestLogin.onclick = () => {
            StorageWrapper.setUserBypassedLogin(true)
            this.handleUserLoginFlow()
        }
    }

    removeLoading() {
        this.loginButtons.forEach((btn) => {
            if(btn == null) return
            btn.classList.remove('loading')
        })
    }

    // eslint-disable-next-line class-methods-use-this
    private handleUserLoginFlow() {
        const loginContainer = document.getElementById('login-container') as HTMLDivElement

        const shouldShowLoginScreen = !ClientUserState.userState?.isLoggedIn && !StorageWrapper.getIfUserBypassedLogin()

        if(shouldShowLoginScreen) {
            loginContainer.style.display = ''
            this.loginButtons.forEach((loginButton) => loginButton.addEventListener('click', () => CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.UserClickedLoginButton)))
        } else {
            loginContainer.style.display = 'none'
            new UIMRequestPushNotification(PushNotificationPopupIntentEnum.OnLoadHomePage)
        }
    }
}
